import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-bim',
  templateUrl: './project-bim.component.html',
  styleUrls: ['./project-bim.component.scss']
})
export class ProjectBimComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
